import {IResponse} from '../../../common/model/Core.model'
import {environment} from '../../../util/Environment'
import {apiSlice} from '../../store/Api'
import { IATask, ITaskCreateRequestDto, ITaskMediaDeleteRequestDto, ITaskUpdateRequestDto } from './Task.model'

export const taskApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      taskMediaDeleteById: builder.mutation<void, ITaskMediaDeleteRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.task}/media/${body.id}?taskId=${body.taskId}`,
            method: 'DELETE',
          }
        },
      }),
      taskSearch: builder.mutation<IResponse, string>({
        query(body) {
          return {
            url: `${environment.apiUrl.task}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      taskGetById: builder.mutation<IATask, {id: string; fields?: string}>({
        query(parameters) {
          const queryParams = parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.task}/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
      taskCreate: builder.mutation<IATask, ITaskCreateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.task}`,
            method: 'POST',
            body,
          }
        },
      }),
      taskUpdateById: builder.mutation<IATask, ITaskUpdateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.task}/${body.id}`,
            method: 'PATCH',
            body,
          }
        },
      }),
      taskDeleteById: builder.mutation<void, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.task}/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useTaskMediaDeleteByIdMutation,
  useTaskSearchMutation,
  useTaskCreateMutation,
  useTaskUpdateByIdMutation,
  useTaskGetByIdMutation,
  useTaskDeleteByIdMutation,
} = taskApi
